import { ApiResult, KeyValuePair } from "@shoothill/core";
import { HttpClient } from "Globals/Helpers/HttpClient/HttpClient";
import { ApiService } from "Globals/Services";
import { SpokenLanguageModel } from "Shared/Models/SpokenLanguageModel";
import { DisabilityImpactModel } from "Shared/Models/DisabilityImpactModel";

// region Interfaces
export interface IGetAllLookupData {
    genderKeyValuePairs: KeyValuePair<string>[];
    salutationKeyValuePairs: KeyValuePair<string>[];
    sharedOwnershipKeyValuePairs: KeyValuePair[];
    employmentStatusKeyValuePairs: KeyValuePair[];
    spokenLanguages: SpokenLanguageModel[];
    developmentalConditionKeyValuePairs: KeyValuePair[];
    supportNeedsKeyValuePairs: KeyValuePair[];
    languageBarrierKeyValuePairs: KeyValuePair[];
    disabilityImpacts: DisabilityImpactModel[];
}
// endregion

export class LookupDataService {
    private apiService = new ApiService();

    public getAllOptions = (): Promise<ApiResult<IGetAllLookupData>> => {
        const endpoint = async (): Promise<ApiResult<IGetAllLookupData>> => {
            return await HttpClient.get<IGetAllLookupData>("/api/lookup/getall");
        };

        return this.apiService.executeCall(endpoint);
    };
}
